"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appStateSchema = exports.PRODUCT_TYPES = exports.HUB_MODULES = void 0;

var _zod = require("zod");

var HUB_MODULES = ['Community', 'Education', 'Event', 'Group', 'Ideation', 'KnowledgeBase', 'ProductUpdates', 'Spaces'];
exports.HUB_MODULES = HUB_MODULES;
var PRODUCT_TYPES = ['community', 'skilljar', 'skilljarlite'];
exports.PRODUCT_TYPES = PRODUCT_TYPES;

var appStateSchema = _zod.z.object({
  appName: _zod.z.enum(['hub', 'forum', 'control']).nullable(),
  activeHubModules: _zod.z.array(_zod.z.enum(HUB_MODULES)),
  activeEntities: _zod.z.record(_zod.z.boolean()),
  // Sourced from the X-GS-Product-Type header via ApplicationState. The header is
  // client-controlled, so .catch(null) keeps SSR parsing robust against unexpected values.
  productType: _zod.z.enum(PRODUCT_TYPES).nullable().optional().catch(null),
  language: _zod.z.string(),
  baseUrl: _zod.z.string().optional(),
  isEmbedded: _zod.z.boolean().optional(),
  skilljarDomain: _zod.z.string().nullable().optional(),
  subfolderPrefix: _zod.z.string().optional(),
  originalBaseUrl: _zod.z.string().optional()
}).default({
  appName: null,
  activeHubModules: [],
  activeEntities: {},
  productType: null,
  language: 'en-US',
  baseUrl: '',
  isEmbedded: false
});

exports.appStateSchema = appStateSchema;